module.exports = __webpack_public_path__ + "img/ic_bouns.4c4a5a53.png";